export default function ComparisonTable() {
  const rows = [
    { feature: "Product Tracking", basetao: "Advanced automated tracking with real-time status updates and multi-item dashboard", traditional: "Manual entry requiring constant user updates — time-consuming and error-prone" },
    { feature: "Price Organization", basetao: "Automated price calculation including domestic shipping, fees, and currency conversion", traditional: "Manual price logging with no built-in calculation formulas or fee estimation" },
    { feature: "Community Data", basetao: "Access to shared templates, seller databases, and crowd-sourced pricing benchmarks", traditional: "Isolated user-managed spreadsheets with no external data integration" },
    { feature: "Shopping Workflow", basetao: "Optimized end-to-end workflow from product discovery through delivery tracking", traditional: "Basic spreadsheet layout requiring significant customization for shopping use cases" },
    { feature: "Updates & Maintenance", basetao: "Frequent template updates reflecting platform changes, new features, and community feedback", traditional: "User-managed updates — templates become outdated without manual intervention" },
  ];

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-4">
          BaseTao Spreadsheet Overview
        </h2>
        <p className="text-sm text-foreground-600 text-center max-w-xl mx-auto mb-12">
          See how BaseTao Spreadsheet compares against traditional spreadsheet solutions across key shopping workflow features.
        </p>

        <div className="hidden md:block overflow-hidden rounded-xl border border-background-200/60">
          <table className="w-full">
            <thead>
              <tr className="bg-background-100">
                <th className="text-left px-6 py-4 text-sm font-semibold text-foreground-800">Feature</th>
                <th className="text-left px-6 py-4 text-sm font-semibold text-primary-700">
                  <span className="flex items-center gap-2">
                    <i className="ri-sparkling-line"></i> BaseTao Spreadsheet
                  </span>
                </th>
                <th className="text-left px-6 py-4 text-sm font-semibold text-foreground-600">
                  <span className="flex items-center gap-2">
                    <i className="ri-file-excel-2-line"></i> Traditional Spreadsheet
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, idx) => (
                <tr key={row.feature} className={`border-t border-background-200/40 ${idx % 2 === 0 ? "bg-background-50" : "bg-background-100/50"}`}>
                  <td className="px-6 py-4 text-sm font-medium text-foreground-800">{row.feature}</td>
                  <td className="px-6 py-4 text-sm text-foreground-700">
                    <span className="flex items-start gap-2">
                      <i className="ri-check-line text-primary-500 mt-0.5 shrink-0"></i>
                      {row.basetao}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm text-foreground-500">
                    <span className="flex items-start gap-2">
                      <i className="ri-close-line text-foreground-400 mt-0.5 shrink-0"></i>
                      {row.traditional}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="md:hidden space-y-4">
          {rows.map((row) => (
            <div key={row.feature} className="rounded-xl border border-background-200/60 p-5 bg-background-100">
              <h4 className="font-heading text-base text-foreground-900 mb-3">{row.feature}</h4>
              <div className="space-y-2">
                <div className="flex items-start gap-2 text-sm text-foreground-700">
                  <i className="ri-check-line text-primary-500 mt-0.5 shrink-0"></i>
                  <span>{row.basetao}</span>
                </div>
                <div className="flex items-start gap-2 text-sm text-foreground-500">
                  <i className="ri-close-line text-foreground-400 mt-0.5 shrink-0"></i>
                  <span>{row.traditional}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}